import React, { useState } from "react";
import Button from "olive-react-myoneui/lib/Button";
import SampleImage2 from "../../../assets/images/sample2.jpg";
import IconDesc from "../my-course/IconDesc";
import { bookIcon, geoMarkIcon, checkCircleIcon, boxOIcon } from "../../../constants/icons";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import Card from "olive-react-myoneui/lib/Card";
import EventScheduleList from "./EventScheduleList";

function CourseEventSchedules({className}) {
  return (
    <div className={`${className || ""}`} >
      <Container>
        <Row className="align-items-center">
          <Col lg={12}>
            <div className="bundle-courses-events p-0">
              <h4 className="fw-bold">Sessions</h4>
            </div>
          </Col>
          <Col lg={12}>
            <Card className="border-0">
              <Card.Body className="p-0">
                <Row>
                  <Col lg={12} className="mb-3">
                    <EventScheduleList />
                  </Col>
                  <Col lg={12} className="mb-3">
                    <EventScheduleList />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CourseEventSchedules;
